import { ControllerRenderProps, FieldPath } from 'react-hook-form';
import { z } from 'zod';
import { Gender } from '../../../types';

export const patientSchema = z.object({
  firstName: z.string().nonempty('Enter a first name').max(45),
  lastName: z.string().nonempty('Enter a last name').max(60),
  middleName: z.string().optional(),
  dateOfBirth: z.string().nonempty('Enter a date of birth'),
  genderName: z.enum(Gender, { message: 'Select a gender.' }),
  contact: z.object({
    phoneNumber: z
      .string()
      .regex(/^\d{10}$/, 'Enter a valid 10-digit phone number')
      .nonempty('Enter a phone number'),
    emailAddress: z
      .union([z.email('Please enter a valid email address.'), z.literal('')])
      .transform((val) => (val === '' ? undefined : val))
      .optional(),
  }),
  organizationProfile: z.string().nonempty('Select a profile.'),
  address: z.object({
    address1: z.string().optional(),
    address2: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    postalCode: z.string().regex(/\d/, 'Should contain only digits').length(5),
  }),
});

export type PatientFormFieldProps<
  T extends keyof z.infer<typeof patientSchema>,
> = {
  field: ControllerRenderProps<z.infer<typeof patientSchema>, T>;
};

// Type for nested field paths like 'address.address1'
export type NestedPatientFormFieldProps<
  T extends FieldPath<z.infer<typeof patientSchema>>,
> = {
  field: ControllerRenderProps<z.infer<typeof patientSchema>, T>;
};

export type PatientFormType = z.infer<typeof patientSchema>;
